//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import tasks from '@/js/tasks';
import MetricsService from '@/apps/data-platform/services/reports/monitoring_driver_connection';
export default {
  name: 'AdminAssessmentReport',
  data: function data() {
    return {
      item: null,
      valid: true,
      report: {},
      readonly: false,
      update_hours: null
    };
  },
  methods: {
    getInfo: function getInfo() {
      var _this = this;
      MetricsService.get_attribute_report().then(function (response) {
        _this.report = response.data;
      });
    },
    updateInfo: function updateInfo() {
      if (!this.$refs.form.validate()) {
        return;
      }
      var data = {
        'data_update': this.report
      };
      MetricsService.update_attribute_report(data).then(function (response) {
        if (response.success && response.code === 200) {
          tasks.toast.success('Change updated!');
        }
      });
    }
  },
  beforeMount: function beforeMount() {
    this.getInfo();
  },
  computed: {
    rules: function rules() {
      var _this2 = this;
      return {
        general: [function (v) {
          return !!v || _this2.translate('reglas.field');
        }]
      };
    },
    getClassTable: function getClassTable() {
      return 'col-sm-12';
    }
  }
};